import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagramStory = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 51.83052 51.81732",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "instagramStory" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 14.23001,
			y1: 26.01827,
			x2: 37.5528,
			y2: 26.01827,
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 25.89141,
			y1: 37.67967,
			x2: 25.89141,
			y2: 14.35688,
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.70451,9.33648a24.8329,24.8329,0,0,1,3.261-2.971",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.25,24.48623a24.543,24.543,0,0,1,2.88291-10.1298",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.72479,44.6941A24.66181,24.66181,0,0,1,1.61012,30.52661",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.60843,49.79805A24.76093,24.76093,0,0,1,13.037,47.11661",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.89141,1.34455A24.69238,24.69238,0,0,1,37.82268,47.6536",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})
	] })]
});
export default SvgInstagramStory;
